module.exports = __webpack_public_path__ + "static/media/How to Pitch Your Product.e2fcea7e.png";